import { collection, doc, getDoc, getDocs, orderBy, query, updateDoc } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { db } from '../../config/firebaseConfig';
import { formatDate, truncateText } from './employeeColumns';

// Çalışanı tüm projelerden aktif/pasif duruma geçir
export const updateEmployeeStatusInProjects = async (employeeId, targetStatus) => {
  try {
    // Çalışanın mevcut proje atamalarını al
    const employeeRef = doc(db, 'Employees', employeeId);
    const employeeDoc = await getDoc(employeeRef);

    if (!employeeDoc.exists()) return;

    const employeeData = employeeDoc.data();
    const projects = employeeData.projects || [];

    // Çalışanın atandığı tüm projeleri güncelle
    const updatePromises = [];

    // Benzersiz proje ID'lerini bul
    const uniqueProjectIds = [...new Set(projects.map(p => p.id))];

    for (const projectId of uniqueProjectIds) {
      const projectRef = doc(db, 'Projects', projectId);
      const projectDoc = await getDoc(projectRef);

      if (projectDoc.exists()) {
        const projectData = projectDoc.data();
        const projectEmployees = projectData.employees || [];

        // Bu çalışanın tüm girişlerini hedef duruma geçir
        const updatedEmployees = projectEmployees.map(emp => {
          if (emp.id === employeeId) {
            return {
              ...emp,
              status: targetStatus
            };
          }
          return emp;
        });

        // Eğer değişiklik varsa güncelle
        const hasChanges = projectEmployees.some(emp => emp.id === employeeId && emp.status !== targetStatus);
        if (hasChanges) {
          updatePromises.push(
            updateDoc(projectRef, { employees: updatedEmployees })
          );
        }
      }
    }

    // Çalışanın kendi projects dizisindeki durumları da güncelle
    const updatedProjects = projects.map(proj => ({
      ...proj,
      status: targetStatus
    }));

    updatePromises.push(
      updateDoc(employeeRef, { projects: updatedProjects })
    );

    await Promise.all(updatePromises);

    console.log(`Çalışan ${employeeId} tüm projelerden ${targetStatus} duruma geçirildi`);
  } catch (error) {
    console.error('Error updating employee status in projects:', error);
    throw error;
  }
};

// "Tabloyu İndir": tüm çalışanların Excel listesi. `messages`: bildirim
// metinleri (geçerli dilde); dosyanın içeriği değişmez.
export const downloadEmployeesExcel = async (messages) => {
  try {
    // Fetch all employees for export
    toast.info(messages.preparing);
    const allEmployeesQuery = query(collection(db, 'Employees'), orderBy('eName'));
    const allEmployeesSnapshot = await getDocs(allEmployeesQuery);
    const allEmployees = allEmployeesSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));

    const ExcelJS = (await import('exceljs')).default;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Employees');
    worksheet.columns = [
      { header: 'First Name', key: 'eName', width: 15 },
      { header: 'Last Name', key: 'eSurname', width: 15 },
      { header: 'TC No', key: 'tcNumber', width: 15 },
      { header: 'Phone', key: 'phone', width: 15 },
      { header: 'Department', key: 'departman', width: 20 },
      { header: 'Exit Date', key: 'employeeExitDate', width: 14 },
      { header: 'Status', key: 'Active', width: 10 }
    ];
    allEmployees.forEach(emp => {
      worksheet.addRow({
        eName: truncateText(emp.eName),
        eSurname: truncateText(emp.eSurname),
        tcNumber: truncateText(emp.tcNumber),
        phone: truncateText(emp.phone),
        departman: truncateText(emp.departman),
        employeeExitDate: formatDate(emp.employeeExitDate),
        Active: emp.Active === 1 ? 'Active' : 'Inactive'
      });
    });
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFE5E7EB' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF111827' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'employees.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);

    toast.success(messages.success);
  } catch (error) {
    console.error('Error downloading Excel file:', error);
    toast.error(messages.error);
  }
};
